import { Injectable } from "@angular/core";

declare global {
  interface Window {
    pendo: any;
  }
}

@Injectable({ providedIn: "root" })
export class WindowRef {
  get nativeWindow(): Window {
    return window;
  }
}
